import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/price-tag.svg';
import { Icon } from '../Icon/Icon';
export const PriceTagIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
